/*eslint-disable*/
import React from 'react'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'

// core components
import styles from '@js/material/components/footerStyle.js'

const useStyles = makeStyles(styles)

export default function Footer(props) {
  const classes = useStyles()
  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <p className={classes.right}>
            Cecarbon &copy; {1900 + new Date().getYear()} Sinduscon-Sp. Todos os direito reservados.
        </p>
      </div>
    </footer>
  )
}
